import { render, staticRenderFns } from "./ListExportCustomsPermitList.vue?vue&type=template&id=062aff14&scoped=true&"
import script from "./ListExportCustomsPermitList.vue?vue&type=script&lang=js&"
export * from "./ListExportCustomsPermitList.vue?vue&type=script&lang=js&"
import style0 from "./ListExportCustomsPermitList.vue?vue&type=style&index=0&id=062aff14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062aff14",
  null
  
)

export default component.exports